module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules.component.css
// module id = ./src/app/rules/rules.component.css
// module chunks = main